import { createApiClient } from '@wix/premium-fed-sdk/apis-infra-react';
import { PackagePickerApiMethodsConfig } from '../../api/apiConfig';
export const PackagePickerApiClient = createApiClient(PackagePickerApiMethodsConfig);
//# sourceMappingURL=ApiProvider.js.map